module.exports = __webpack_public_path__ + "img/hello.782872ad.jpg";